const initHomepageHeading = () => {
    const flickitySlidersArray = initCarousel("[data-heading-slider] [data-slider]", cellAlign.left, true, false, true, false, false, null, true);
    /*responsiveBackground();*/
    flickitySlidersArray && flickitySlidersArray.forEach(flickitySlider => {
        //show current slide index
        const currentSlideIndex = flickitySlider.slider.closest("[data-heading-slider]").querySelector("[data-current-slide-index]");
        flickitySlider.on("change", () => {
            currentSlideIndex.innerHTML = (flickitySlider.selectedIndex + 1).toString();
        });
        //custom binding to buttons
        const prevButton = flickitySlider.slider.closest("[data-heading-slider]").querySelector("[data-prev-button]");
        //custom binding to prev button
        prevButton.addEventListener("click", () => {
            flickitySlider.previous();
        });
        //custom binding to next button
        const nextButton = flickitySlider.slider.closest("[data-heading-slider]").querySelector("[data-next-button]");
        nextButton.addEventListener("click", () => {
            flickitySlider.next();
        });
    });
    //init vimeo
    const video = document.querySelector("[data-heading-video]");
    if (video) {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://player.vimeo.com/api/player.js`;
        document.head.appendChild(script);
    }
};
const responsiveBackground = () => {
    const headingWidget = document.querySelector("[data-heading-slider]");
    if (headingWidget) {
        const headingsList = headingWidget.querySelectorAll("[data-heading]");
        headingsList.forEach((heading) => {
            const backgroundImageDesktop = heading.getAttribute("data-desktop");
            const backgroundImageMobile = heading.getAttribute("data-mobile");
            if (window.innerWidth > 390) {
                heading.setAttribute("style", `background-image: url(${backgroundImageDesktop})`);
            }
            else {
                heading.setAttribute("style", `background-image: url(${backgroundImageMobile})`);
            }
        });
    }
};
